export const LoadingSpinner = ({ size = 12 }: { size?: number }) => (
    <div className="flex justify-center items-center h-full w-full py-12">
        <div
            className="animate-spin rounded-full border-4 border-primery-blue-500 border-t-transparent"
            style={{
                width: `${size * 0.25}rem`,
                height: `${size * 0.25}rem`,
            }}
        >
            <span className="sr-only">Loading...</span>
        </div>
    </div>
);
